/* eslint-disable no-alert */
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { Country, I18nModule, UrlModule } from '@spartacus/core';
import { CustomFormValidators, FormErrorsModule, NgSelectA11yModule, sortTitles } from '@spartacus/storefront';
import { RegisterComponentService } from '@spartacus/user/profile/components';
import { Title } from '@spartacus/user/profile/root';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { CustomValidatorService } from '../../../../../components/form-elements/custom-validator.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { BtnVisibilityComponent } from '../../../user/account/components/login-form/btn-visibility/btn-visibility.component';
import { VISIBILITY } from '../../../user/account/components/login-form/btn-visibility/core/btn-visibility.model';
import { CountriesDropdownComponent } from '../../../../../components/form-elements/countries-dropdown/countries-dropdown.component';
import { Option } from '../../../../../core/models/option.model';
import { countrieData } from '../../../../../components/form-elements/countries-dropdown/core/countries.data';

@Component({
  selector: 'demo-form',
  standalone: true,
  imports: [
    CommonModule,
    I18nModule,
    FormErrorsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    NgSelectModule,
    NgSelectA11yModule,
    NgxMaskDirective,
    BtnVisibilityComponent,
    CountriesDropdownComponent,
  ],
  providers: [RegisterComponentService, provideNgxMask()],
  templateUrl: './demo-form.component.html',
  styleUrl: './demo-form.component.scss',
})
export class DemoFormComponent {
  titles$: Observable<Option[]> = this.registerComponentService.getTitles().pipe(
    map((titles: Title[]) => titles.sort(sortTitles)),
    map((items: any) => {
      return (items || []).map((item: any) => ({
        code: item.code,
        label: item.name,
      }));
    }),
  );

  country?: Country;
  countries$ = new BehaviorSubject<Country[]>(
    countrieData.map(country => ({
      name: country.name,
      isocode: country.acronym,
      diallingCode: country.dialling_code,
      phoneMask: country.phoneMask,
    })),
  );

  subscriptiontype$ = of([
    {
      code: 'basic',
      value: 'Basic',
    },
    {
      code: 'premium',
      value: 'Premium',
    },
    {
      code: 'vip',
      value: 'VIP',
    },
  ]);

  form: FormGroup = this.fb.group(
    {
      titleCode: ['', [this.customValidatorService.required()]],
      country: ['', [this.customValidatorService.required()]],
      firstName: ['', [this.customValidatorService.required()]],
      document: ['', [this.customValidatorService.required()]],
      phone: ['', [this.customValidatorService.required()]],
      email: ['', [this.customValidatorService.required(), CustomFormValidators.emailValidator]],
      password: ['', [this.customValidatorService.required(), CustomFormValidators.passwordValidators]],
      passwordconf: ['', [this.customValidatorService.required()]],
      termsandconditions: [false, [Validators.requiredTrue]],
      subscriptiontype: ['basic', [this.customValidatorService.required()]],
      comment: ['', []],
    },
    {
      validators: CustomFormValidators.passwordsMustMatch('password', 'passwordconf'),
    },
  );

  constructor(
    protected fb: FormBuilder,
    protected registerComponentService: RegisterComponentService,
    private customValidatorService: CustomValidatorService,
  ) {}

  setInputType(status: VISIBILITY, $input: HTMLInputElement) {
    $input.type = status === VISIBILITY.VISIBLE ? `text` : `password`;
  }

  setCountry(country: Country) {
    this.form.get(`country`)?.setValue(country?.isocode, '');
    this.country = country;
  }

  validateInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9()-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  submit() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      alert('Form Validado');
    }
  }
}
